/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_View_WeekInputs */



/**
* | output |
* | --- |
* | "Week" |
*
* @param {Agenda_View_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_view_week = /** @type {((inputs?: Agenda_View_WeekInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_View_WeekInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Semaine")
	return /** @type {LocalizedString} */ ("Week")
});